import { RouterProvider } from 'react-router-dom'

// import { AuthProvider } from '@/contexts'
import { ToastProvider } from '@/components/providers/ToastProvider'
import { router } from '@/router'

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastProvider />
    </>
  )
}

export default App
